import { render, staticRenderFns } from "./CheckSpillover.vue?vue&type=template&id=15c227cc&scoped=true"
import script from "./CheckSpillover.vue?vue&type=script&lang=js"
export * from "./CheckSpillover.vue?vue&type=script&lang=js"
import style0 from "./CheckSpillover.vue?vue&type=style&index=0&id=15c227cc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15c227cc",
  null
  
)

export default component.exports